export enum State {
  selection          = "SELECTION",
  approval           = "APPROVAL",
  deleteConfirmation = "DELETE_CONFIRMATION",
  upload             = "UPLOAD",
  success            = "SUCCESS",
  error              = "ERROR"
}

export default State